// Privileges that belong to the user rather than to a shop. Privileges are
// stored per target (`{ shopID, priv }`), but these views don't depend on the
// selected target, so when the user holds one on its source target it is made
// available on every target the user switches to.
export const USER_LEVEL_PRIVILEGES: {
  privilege: string;
  sourceTarget: string;
}[] = [
  { privilege: 'team_dashboard', sourceTarget: 'tomtailorde' },
  { privilege: 'behamics_support_chat', sourceTarget: 'tomtailorde' },
];

export function withUserLevelPrivileges(
  privileges: string[] | undefined,
  allUserTargetPrivileges: any[] | undefined,
): string[] | undefined {
  const missing = USER_LEVEL_PRIVILEGES.filter(
    ({ privilege, sourceTarget }) =>
      !(privileges || []).includes(privilege) &&
      (allUserTargetPrivileges || []).some(
        (entry: any) =>
          entry?.shopID === sourceTarget &&
          Array.isArray(entry?.priv) &&
          entry.priv.includes(privilege),
      ),
  ).map(({ privilege }) => privilege);

  if (missing.length == 0) return privileges;
  return [...(privileges || []), ...missing];
}
